"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const buildError_1 = tslib_1.__importDefault(require("./buildError"));
/**
 * A function that builds a specific server error for errors that are not Axios errors.
 * @param {object} error
 * @param {string} url
 * @param {object} options
 */
const handleServerError = (error, url, options) => {
    const statusText = `Internal server error.
  The server encountered an unexpected condition which prevented it from fulfilling the request.
  ${JSON.stringify(error)}`;
    throw (0, buildError_1.default)(500, statusText, url, options);
};
exports.default = handleServerError;
//# sourceMappingURL=handleServerError.js.map